import { Router } from './components/Router';
import { EventPage } from './pages/EventPage';
import { About } from './pages/About';
import { Backup } from './pages/Backup';
import { Interrupt } from './pages/Interrupt';

/**
 * App Component - Main application entry point with routing
 * 
 * Routes:
 * - / - Main event page
 * - /about - About page with disclaimer, copyright, and features
 * - /backup - Hidden backup page with EventInfo, ForgeChallenge, and SideQuests
 * - /interrupt - Hidden interrupt page with urgent ForgeInterrupt challenge
 */
function App() {
  return (
    <Router 
      routes={[
        { path: '/', component: EventPage },
        { path: '/about', component: About },
        { path: '/backup', component: Backup },
        { path: '/interrupt', component: Interrupt }
      ]} 
    />
  );
}

export default App;
